var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"m-counter flex jc-sb",class:_vm.step > 0 ? '_show':'_hide'},_vm._l((_vm.total),function(item,key){return _c('li',{key:key,staticClass:"m-counter--item",class:{'m-counter_active': _vm.step > key }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }